<template>
  <v-content>
    <section
      id="cover"
      :style="coverImageSrc"
    >
      <div class="section-contents">
        <h1>MENU</h1>
        <p>{{subTitle}}</p>
      </div>
    </section>
    <section id="search">
      <div class="wrapper">
        <div class="mobile my-3 pl-3">
          <span class="font-weight-black title">
            <v-icon>mdi-pound-box</v-icon>해시태그 검색
          </span>
        </div>
        <div class="selected-tag">
          <div class="tag-container">
            <transition-group
              name="list"
              tag="div"
              class="tag-list"
            >
              <v-chip
                color="#686059"
                text-color="white"
                v-for="(item, i) in selectedTagList"
                :key="i"
                @input="onClose(item)"
                close
                class="font-weight-bold"
              >
                {{ '# ' + item }}
              </v-chip>
            </transition-group>

            <div class="tag-overlay"></div>
          </div>
        </div>
        <div class="mobile my-3 pl-3">
          <span class="font-weight-bold">다양한 메뉴를 태그선택으로 찾아보세요</span>
        </div>
        <hr class="mobile" />
        <div class="unselected-tag">
          <div class="tag-title">
            <!-- <v-icon size="60" class="mr-2 pound-icon">mdi-pound</v-icon> -->
            <h2 class="pt-1">더브라운만의 다양한 메뉴들을<br />태그 선택으로 찾아보세요.</h2>
            <h2 class="mobile">태그선택</h2>
          </div>
          <div class="tag-container">
            <!-- <div class="tag-list"> -->
            <transition-group
              name="list"
              tag="div"
              class="tag-list"
            >
              <v-chip
                v-for="(item, i) in getTagList"
                :key="i"
                color="#d9d9d9"
                text-color="#686059"
                disabled
                class="font-weight-bold"
                @click="tagSelect(item)"
              >
                {{ '# ' + item }}
              </v-chip>
            </transition-group>
            <!-- </div> -->
            <div class="tag-overlay"></div>
          </div>
        </div>
        <hr class="web" />
      </div>
    </section>
    <section id="gallery">
      <v-container
        grid-list-lg
        contents
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            md6
          >
            <v-card
              dark
              color="#eeedec"
              tile
              elevation="0"
              class="over-hidden signature-menu"
            >
              <!-- <v-img
                src="images/menu-eggbenedict-set.jpeg"
                cover
                aspect-ratio="1"
              > </v-img> -->
              <v-img
                cover
                aspect-ratio="1"
                :src="signatureMenuImageSrc"
              > </v-img>
              <!-- <v-img src="https://source.unsplash.com/KejgVx9bVTc/500x500" cover aspect-ratio="1"> </v-img> -->
              <span class="title-overlay">{{signatureMenu.name}}</span>
              <div class="desc-overlay">
                <div class="overlay-header">
                  <div class="line">
                    <hr />
                  </div>
                  <div class="menu-title">
                    <h1>
                      Signature
                      <span>menu</span>
                    </h1>
                  </div>
                  <div class="line">
                    <hr />
                  </div>
                </div>
                <div class="overlay-body">
                  <h1>{{signatureMenu.name}}</h1>
                  <p class="desc part1">{{signatureMenu.descPt1}}</p>
                  <p class="desc part2">{{signatureMenu.descPt2}}</p>
                  <hr />
                  <div class="overlay-tag">
                    <ul>
                      <li
                        v-for="( tag, i) in signatureMenu.tagList"
                        :key=i
                      >{{tag}}</li>
                    </ul>
                  </div>
                </div>
                <div class="bottom-spacer"></div>
              </div>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                v-for="item in filterdMenuList.slice(0,4) "
                :key="item.name"
                xs6
              >
                <v-card
                  dark
                  color="#eeedec"
                  tile
                  flat
                  class="menu"
                >
                  <div class="badge-container">
                    <span :class="['badge', (item.badge||[])[0]? 'best' : 'none']"></span>
                    <span :class="['badge', (item.badge||[])[1]? 'new' : 'none']"></span>
                    <span :class="['badge', (item.badge||[])[2]? 'season' : 'none']"></span>
                  </div>
                  <v-img
                    :src="'/images/menu/'+ item.imgFileName"
                    contain
                    aspect-ratio="1"
                  > </v-img>
                  <span class="title-overlay">{{item.name}}</span>
                  <div class="desc-overlay">
                    <div class="overlay-header">
                      <!-- <div class="line">
                        <hr />
                      </div> -->
                      <div class="menu-title">
                        <h1>
                          {{subTitle}}
                          <span>menu</span>
                        </h1>
                      </div>
                      <!-- <div class="line">
                        <hr />
                      </div> -->
                    </div>
                    <div class="overlay-body">
                      <h1 v-if="iceBreak(item.name)">아이스 <br /> {{iceBreak(item.name)}}</h1>
                      <h1 v-else>{{item.name}}</h1>
                      <p class="desc part1">{{item.desc}}</p>
                      <!-- <p class="desc part2">이번 봄/여름 시즌에만 맛볼수 있는 브런치메뉴</p> -->
                      <hr />
                    </div>
                    <div class="overlay-tag">
                      <ul>
                        <li v-for="( tag, i) in item.tagList">{{tag}}</li>
                      </ul>
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md12
          >
            <v-layout
              row
              wrap
              v-if="filterdMenuList.length > 4"
            >
              <v-flex
                v-for="item in filterdMenuList.slice(4) "
                :key="item.name"
                xs6
                md3
              >
                <v-card
                  dark
                  color="#eeedec"
                  tile
                  elevation="0"
                  class="menu"
                >
                  <div class="badge-container">
                    <span :class="['badge', (item.badge||[])[0]? 'best' : 'none']"></span>
                    <span :class="['badge', (item.badge||[])[1]? 'new' : 'none']"></span>
                    <span :class="['badge', (item.badge||[])[2]? 'season' : 'none']"></span>
                  </div>
                  <v-img
                    :src="'/images/menu/'+ item.imgFileName"
                    contain
                    aspect-ratio="1"
                  > </v-img>
                  <span class="title-overlay">{{item.name}}</span>
                  <div class="desc-overlay">
                    <div class="overlay-header">
                      <!-- <div class="line">
                        <hr />
                      </div> -->
                      <div class="menu-title">
                        <h1>
                          {{subTitle}}
                          <span>menu</span>
                        </h1>
                      </div>
                      <!-- <div class="line">
                        <hr />
                      </div> -->
                    </div>
                    <div class="overlay-body">
                      <h1 v-if="iceBreak(item.name)">아이스 <br /> {{iceBreak(item.name)}}</h1>
                      <h1 v-else>{{item.name}}</h1>
                      <p class="desc part1">{{item.desc}}</p>
                      <!-- <p class="desc part2">이번 봄/여름 시즌에만 맛볼수 있는 브런치메뉴</p> -->
                      <hr />
                    </div>
                    <div class="overlay-tag">
                      <ul>
                        <li v-for="( tag, i) in item.tagList">{{tag}}</li>
                      </ul>
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </v-content>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
export default {
  props: ['subPage'],
  created () {
    this.$nextTick(async () => {
      // console.log('created!', this.menuListAll)
      this.menuListAll = await axios.get(document.api_host + '/menus.json')
        .then(({ data }) => {
          return data
        })
        .catch(err => console.error('no data ( data fetch error )'))
      this.menuList = _.sortBy(this.menuListAll.filter(menu => (menu.category === this.subPage && !menu.isSignature)).map(m => ({...m, seq: Number(m.seq)})), 'seq')
      this.signatureMenuList = this.menuListAll.filter(menu => menu.isSignature)
      this.signatureMenu = this.signatureMenuList.filter(menu => (menu.category === this.subPage))[0]

      this.signatureMenuImageSrc = '/images/menu/' + this.signatureMenu.imgFileName
      // this.tagList = this.getTagList()
      // console.log(this.menuList.slice(0, 4))
      // console.log(this.menuList.slice(4))
    })
  },
  mounted () {
    // console.log(this.subPage, this.id)

    if (this.subPage === 'coffee') {
      this.coverImageSrc = `background-image:url('/images/menu-coffee-cover.jpg');`
      this.subTitle = 'Coffee & Drink'
    }
    else if (this.subPage === 'bakery') {
      this.coverImageSrc = `background-image:url('/images/TB_bakery.jpg');`
      this.subTitle = 'Bakery & Cake'
    }
    else {
      this.coverImageSrc = ''
      this.subTitle = 'Brunch & Food'
    }

  },
  watch: {
    '$route' (to, from) {
      // console.log(from, '->', to)
      this.signatureMenu = this.signatureMenuList.filter(menu => (menu.category === to.params.subPage))[0]
      this.menuList = _.sortBy(this.menuListAll.filter(menu => (menu.category === this.subPage && !menu.isSignature)).map(m => ({...m, seq: Number(m.seq)})), 'seq')
      this.selectedTagList = []
      this.signatureMenu = this.signatureMenuList.filter(menu => (menu.category === this.subPage))[0]
      this.signatureMenuImageSrc = '/images/menu/' + this.signatureMenu.imgFileName
      if (to.params.subPage === 'coffee') {
        this.coverImageSrc = `background-image:url('/images/menu-coffee-cover.jpg');`
        this.subTitle = 'Coffee & Drink'
      } else if (to.params.subPage === 'bakery') {
        this.coverImageSrc = `background-image:url('/images/TB_bakery.jpg');`
        this.subTitle = 'Bakery & Cake'
      } else {
        this.coverImageSrc = ''
        this.subTitle = 'Brunch & Food'
      }
    }
  },
  computed: {
    getTagList () {
      function notContainedIn (arr) {
        return function arrNotContains (element) {
          return arr.indexOf(element) === -1;
        };
      }
      //전체 아이템의 태그리스트 중복제거
      const r = Array.from(new Set([].concat.apply([], this.menuList.map(menu => menu.tagList))))
      // console.log('==> ', r)
      if (this.selectedTagList.length === 0) {

        //태그별로 카운트 해서 많은 순서로 탑텐
        const t = [].concat.apply([], this.menuList.map(menu => menu.tagList))
        const result = _.entries(_.countBy(t)).map(([name, count]) => ({ name, count }))
        const sortedList = _.sortBy(result, 'count').reverse().slice(0, 10).map(obj => obj.name)

        // console.log('>>>', sortedList)
        return sortedList
      }
      else {

        const tagSelectedMenuList = this.menuList.filter(menu => menu.tagList.some(tag => this.selectedTagList.includes(tag)))

        const selectedTagList = Array.from(new Set([].concat.apply([], tagSelectedMenuList.map(menu => menu.tagList))))

        return selectedTagList.filter(notContainedIn(this.selectedTagList)).slice(0, 10)

        // .filter(notContainedIn(this.selectedTagList))

      }
      // return r.filter(notContainedIn(this.selectedTagList.filter(tag => tag.isSelected).map(tag => tag.name)));
    },
    filterdMenuList () {
      let f = this.menuList.slice(0)
      // if (this.selectedTagList.length > 0 && this.selectedTagList.filter(tag => tag.isSelected).length > 0) {
      if (this.selectedTagList.length > 0) {

        f = f.filter(menu => menu.tagList.some(tag => this.selectedTagList.includes(tag)))

      }
      return f

    }
  },
  data () {
    return {
      signatureMenuImageSrc: '',
      coverImageSrc: '',
      subTitle: 'Bakery & Cake',
      onFocus: {
        transform: 'scale(1.3)'
      },
      selectedTagList: [],
      menuList: [],
      signatureMenu: {},
      signatureMenuList: [],
      menuListAll: []
    }
  },
  methods: {
    iceBreak (str) {
      if (str.length > 0) {
        const strArr = str.split(/\s/)
        if (strArr.length > 1) {
          if (strArr[0] === '아이스') {
            return strArr.slice(1).join(' ')
          } else return null
        } else {
          return null
        }
      } else {
        return null
      }
    },
    onClose (tag) {
      const idx = this.selectedTagList.indexOf(tag)
      if (idx > -1) this.selectedTagList.splice(idx, 1)
    },
    onSetTranslate () {
      console.log('onSetTranslate')
    },
    tagSelect (tag) {
      console.log(tag)
      this.selectedTagList.push(tag)

    },
    getImage () {
      // const str = 'https://source.unsplash.com/collection/'
      // const collectionList = ['622217/', '1757223/', '2268129/']
      // const sizeList = ['300x300', '400x400', '350x350']
      // return str + collectionList[Math.floor(Math.random() * 3)] + sizeList[Math.floor(Math.random() * 3)]
    },
    getTagSelected () {
      return this.tagList.filter(e => e.selected)
    },
  },
}
</script>

<style lang="css" scoped>
/*transition*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.list-item {
  /* display: inline-block; */
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-30px);
}
/* section */
.mobile {
  display: none;
}
#cover {
  /* background-image: url("/images/menu-brunch-cover.jpg"); */
  background-image: url("/images/TB_brunch.jpg");
  /* background-size: auto 600px; */
   background-position: center 80%;
  background-repeat: repeat-x;
  /* background-attachment: fixed; */
  background-size: cover;
  max-width: 1500px;

  margin: 130px auto 0px auto;
  height: 470px;
  font-family: "europa";
}

#cover h1 {
  box-sizing: border-box;
  font-size: 70px;
  font-weight: 700;
  color: white;
  /* color: #686059; */
}
#cover p {
  box-sizing: border-box;
  /* margin-top: -25px; */
  font-weight: 400;
  font-size: 40px;
  color: white;
  /* color: #686059; */
}
#search {
  padding: 40px 40px 0px 40px;
  width: 100%;
  height: 200px;
}
#search div.wrapper {
  max-width: 1420px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  /* border-bottom: 5px solid #686059; */
  padding-bottom: 20px;
}

#search div.selected-tag {
  margin-bottom: 20px;
  min-height: 50px;
}

#search hr {
  border-top: 4px solid #686059;
}
#search hr.web {
  margin-top: 20px;
}

#search div.unselected-tag {
  display: flex;
}
#search div.unselected-tag div.tag-title {
  background-image: url("../assets/images/Main_right_arrow.png");
  background-size: contain;
  background-position-x: 100%;
  background-position-y: center;
  flex: 0 0 300px;
  display: flex;
  margin-right: 20px;
}

#search div.unselected-tag div.tag-title h2 {
  flex: 1;
  font-size: 20px;
  font-weight: 600;
  color: #686059;
  line-height: 30px;
  letter-spacing: 0px;
}
#search div.unselected-tag div.tag-title h2.mobile {
  display: none;
}

#search div.tag-container {
  flex: 1 1 calc(100% - 300px);
  /* padding: 20px 0px 0px 10px; */
  padding: 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#search div.tag-container > div.tag-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 40px;
  pointer-events: none;
  /* display: none; */
  /* background: rgba(238, 237, 236,1) */
  background: linear-gradient(
    to right,
    rgba(238, 237, 236, 0),
    /* rgba(238, 237, 236, 0.5) 5%,
    rgba(238, 237, 236, 0) 10%, */
      rgba(238, 237, 236, 0) 90%,
    rgba(238, 237, 236, 0.5) 95%,
    rgba(238, 237, 236, 1)
  );
}

#search div.tag-container > div.tag-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  /* overflow-x: hidden; */
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

#search div.tag-container > div.tag-list::-webkit-scrollbar {
  display: none;
}
#search div.tag-container > div.tag-list > span {
  /* flex: 0 0 auto; */
  border-radius: 30px !important;
}
#search .v-chip {
  font-size: 15px;
}

/* #search .v-chip--selected {
  opacity: 1;
} */

#gallery {
  width: 100%;
  padding: 0px 16px;
}
#gallery .contents {
  max-width: 1468px !important;
}

#gallery div.v-card {
  border: 1px solid #c7c4c1 !important;
}

#gallery .over-hidden {
  overflow: hidden;
}
.focus {
  transform: scale(1.3);
}

span.title-overlay {
  text-align: center;
  display: block;
  /* width: 300px; */
  /* height: 30px; */
  min-width: 200px;
  position: absolute;
  top: 85%;
  left: 50%;
  font-size: 18px;
  font-weight: 600;
  color: #686059;
  word-break: keep-all;
  /* text-shadow: 1px 2px 3px grey; */
  z-index: 100;
  transform: translateX(-50%);
  transition: opacity 0.7s ease-out;
}
div.menu > div.badge-container {
  position: absolute;
  z-index: 120;
  top: 5%;
  right: 5%;
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

span.badge.none {
  display: none;
}
span.badge {
  position: relative;
  display: inline-block;
  margin-left: 5px;
}
span.badge.best {
  width: 30%;
  height: 30%;
  background-image: url("../assets/images/badge-BEST.png");
  background-size: contain;
}
span.badge.season {
  width: 30%;
  height: 30%;
  background-image: url("../assets/images/badge-SEASON.png");
  background-size: contain;
}
span.badge.new {
  width: 30%;
  height: 30%;
  background-image: url("../assets/images/badge-NEW.png");
  background-size: contain;
}

.signature-menu span.title-overlay {
  height: 50px;
  top: 80%;
  font-size: 20px;
  /* z-index: 100; */
  color: white;
}

div.desc-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  /* top: -100%; */
  left: 0;
  top: 0;
  opacity: 0;
  /* opacity: 1; */
  /* background-color: rgba(104, 96, 89, 0.8); */
  transition: all 0.7s ease-in;
  padding: 0;
  z-index: 200;
  pointer-events: none;
  display: flex;
  flex-direction: column;
}
div.desc-overlay hr {
  border: 0px;
  height: 2px;
  width: 100%;
  background-color: white;
  opacity: 0.5;
}

div.desc-overlay > div.overlay-header {
  /* margin-top: -10px; */
  display: flex;
  justify-content: space-between;
  flex: 1;
  /* height: 20%; */
  max-height: 25%;
  flex-basis: 25%;
  /*min-height: 60px; */
}

div.desc-overlay > div.overlay-header > div {
  flex: 1;
}
div.desc-overlay > div.overlay-header > div.line > hr {
  display: none;
}
.signature-menu div.desc-overlay > div.overlay-header > div.line > hr {
  display: block;
}

.signature-menu div.desc-overlay > div.overlay-header > div.line {
  display: flex;
  align-items: center;
  /* padding: 0px 20px 30% 20px; */
  justify-content: center;
}

div.desc-overlay > div.overlay-header h1 {
  width: 100%;
  font-family: "nexa-rust-script";
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  /* text-shadow: 0 0 2px white; */
}
.signature-menu div.desc-overlay > div.overlay-header h1 {
  font-size: 70px;
}
div.desc-overlay > div.overlay-header h1 > span {
  display: none;
}
.signature-menu div.desc-overlay > div.overlay-header h1 > span {
  display: block;
  margin-top: -45px;
  font-size: 55px;
}
div.desc-overlay > div.overlay-header > div.menu-title {
  margin: 0px 0px;
  display: flex;
  align-items: center;
}

div.desc-overlay > div.overlay-body {
  /* max-height: 80%;
  height: 60%;; */
  display: flex;
  align-items: center;
  flex-direction: column;
  /* flex: 1; */
  flex-grow: 1;
  justify-content: center;
  /* justify-content: space-between; */
}

.signature-menu div.desc-overlay > div.overlay-body {
  flex-basis: 50%;
  max-height: 50%;
  flex: 1;
  justify-content: flex-end;
}

div.desc-overlay > div.overlay-body h1 {
  text-align: center;
  font-size: 28px;
  word-break: keep-all;
  font-weight: 600;
  letter-spacing: -1px;
}

.signature-menu div.desc-overlay > div.overlay-body h1 {
  font-size: 35px;
  font-weight: 900;
  /* text-shadow: 0 0 2px white; */
}

div.desc-overlay > div.overlay-body p {
  text-align: center;
  word-break: keep-all;
  font-size: 15px;
  font-weight: 400;
  max-width: 65%;
  line-height: 22px;
  padding: 5px 0px;
  margin-bottom: 10px;
  letter-spacing: 0px;
}

div.desc-overlay > div.overlay-body p.part2 {
  display: none;
}
.signature-menu div.desc-overlay > div.overlay-body p.part2 {
  display: block;
}
.signature-menu div.desc-overlay > div.overlay-body p {
  max-width: 40%;
  font-size: 15px;
  line-height: 20px;
}
div.desc-overlay > div.overlay-body hr {
  margin: 10px 0px;
  width: 80%;
}
.signature-menu div.desc-overlay > div.overlay-body hr {
  margin: 10px 0px;
  width: 40%;
}

div.desc-overlay div.overlay-tag {
  flex: 1;
  max-height: 20%;
}
div.desc-overlay div.overlay-tag ul {
  padding-left: 0px !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -1px;
  color: #fbd2af;
}
/* .signature-menu div.desc-overlay > div.overlay-tag ul {} */
div.desc-overlay div.overlay-tag li {
  margin: 0px 3px;
}
div.desc-overlay div.overlay-tag li:before {
  content: "#";
}

.swiper-container {
  height: 300px;
  width: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  background-color: #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/* .v-responsive__content:hover ~ .v-image__image {
  transform: scale(1.3);
} */

@media (max-width: 1023px) {
  .mobile {
    display: initial;
  }
  #cover {
    margin-top: 80px;
    height: 220px;
    /* background-size: auto 220px;
    background-position-y: 80px;
    background-position-x: left; */
  }
  #cover .section-contents {
    padding: 20px;
  }
  #cover h1 {
    font-size: 40px;
  }
  #cover p {
    margin-top: -10px;
    font-size: 30px;
  }
  #search {
    padding: 0px;
    height: auto;
  }

  #search div.wrapper {
    max-width: 1420px;
    padding: 0px;

    /* display: flex;
    flex-direction: column;
    justify-content: flex-start; */
  }
  #search div.wrapper hr {
    margin-bottom: 20px;
  }
  #search hr.web {
    margin-top: 0px;
  }
  #search div.selected-tag {
    margin-bottom: 0px;
    /* border-bottom: 2px solid #686059; */
  }
  #search div.unselected-tag {
    /* border-top: 5px solid #686059; */
    display: block;
    height: 60px;
  }

  #search .pound-icon {
    display: none;
  }
  #search div.unselected-tag div.tag-title {
    flex: 0 0 70px;
    display: none;
  }
  #search div.unselected-tag div.tag-title h2 {
    display: none;
  }
  #search div.unselected-tag div.tag-title h2.mobile {
    /* display: block !important; */
    height: 60px;
    line-height: 60px;
  }
  #search div.unselected-tag div.arrow {
    display: none;
    flex: 0 0 30px;
    background-size: auto 30px;
  }

  #search .search {
    max-width: 100%;
    padding-right: 0px;
    min-width: 300px;
    position: relative;
    margin-right: 0px;
    margin-bottom: 20px;
  }

  span.title-overlay {
    width: 100%;
    max-height: 50px;
    overflow-y: hidden;
    top: 85%;
    font-size: 12px;
    text-shadow: initial;
    transition: opacity 0.7s ease-out;
  }
  .signature-menu span.title-overlay {
    font-size: 25px;
    top: 80%;
  }
  #gallery div.desc-overlay > div.overlay-header {
    flex: 1 1 25%;
    max-height: 30px;
  }
  #gallery div.desc-overlay > div.overlay-header h1 {
    font-size: 15px;
  }
  #gallery div.desc-overlay > div.overlay-body {
    flex: 1 1 30%;
    /* max-height: 50px; */
  }
  #gallery div.desc-overlay > div.overlay-body h1 {
    font-size: 15px;
    text-shadow: initial;
    text-align: center;
  }
  #gallery div.desc-overlay > div.overlay-body p {
    display: none;
  }
  #gallery div.desc-overlay > div.overlay-body hr {
    margin-top: 10px;
    margin-bottom: 0px;
  }

  #gallery div.desc-overlay > div.overlay-tag {
    flex: 1 1 45%;
  }
  #gallery div.desc-overlay > div.overlay-tag > ul {
    font-size: 12px;
    font-weight: 600;
    /* overflow-y: hidden;
    max-height: 25px; */
  }
  div.desc-overlay > div.overlay-tag li {
    margin: 0px 3px 0px 0px;
  }
  #gallery .signature-menu div.desc-overlay > div.overlay-header {
    flex: 1 1 30%;
    max-height: initial;
  }
  #gallery .signature-menu div.desc-overlay > div.overlay-header h1 {
    font-size: 40px;
  }
  #gallery .signature-menu div.desc-overlay > div.overlay-header div.line {
    padding: 0px 10px;
  }
  #gallery
    .signature-menu
    div.desc-overlay
    > div.overlay-header
    div.menu-title {
    margin: 0px 10px;
  }
  #gallery .signature-menu div.desc-overlay > div.overlay-header h1 span {
    font-size: 20px;
    margin-top: -20px;
  }
  #gallery .signature-menu div.desc-overlay > div.overlay-body {
    flex: 1 1 55%;
  }

  #gallery .signature-menu div.desc-overlay > div.overlay-body h1 {
    font-size: 20px;
  }
  #gallery .signature-menu div.desc-overlay > div.overlay-body p {
    display: block;
    font-size: 13px;
    max-width: 70%;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
  #gallery .signature-menu div.desc-overlay > div.overlay-body hr {
    margin: 10px 0px;
  }
  #gallery .signature-menu div.desc-overlay > div.bottom-spacer {
    flex: 1 1 15%;
  }
}
</style>